<mat-form-field appearance="fill" (click)="loadPlants()">
   <mat-label>Simulate login</mat-label>
   <mat-select matNativeControl>
     <mat-option (click)="startSimulation(customer.EnterpriseId)">
        As Customer Admin
      </mat-option> 
   </mat-select>
 </mat-form-field>